import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 20 20'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M7.548 14.583q-.63 0-1.069-.437a1.45 1.45 0 0 1-.437-1.07V3.59q0-.632.437-1.07a1.45 1.45 0 0 1 1.07-.437h6.986q.631 0 1.07.438.436.437.437 1.069v9.487q0 .63-.438 1.069a1.46 1.46 0 0 1-1.069.437zm0-1.25h6.987a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.176V3.59a.25.25 0 0 0-.08-.177.25.25 0 0 0-.176-.08H7.548a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.177v9.487q0 .096.08.176t.176.08M4.631 17.5q-.63 0-1.069-.438a1.45 1.45 0 0 1-.437-1.069V5.256h1.25v10.737q0 .097.08.177t.176.08h8.238v1.25z'
    />
  </svg>
)
export default SvgComponent
